import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const { FiCalendar, FiCamera, FiVideo, FiMessageSquare, FiTarget, FiZap } = FiIcons;

const Deliverables = () => {
  const { t } = useLanguage();
  const icons = [FiCalendar, FiCamera, FiVideo, FiMessageSquare, FiTarget, FiZap];

  return (
    <section className="py-24 px-6 bg-zinc-950">
      <div className="max-w-6xl mx-auto">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }}
          className="text-3xl md:text-5xl font-bold text-white text-center mb-16"
        >
          {t.deliverables.h2}
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.deliverables.items.map((item, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex flex-col items-start p-8 bg-zinc-900 border border-white/5 rounded-xl"
            >
              <div className="w-12 h-12 bg-orange-500/10 rounded-lg flex items-center justify-center mb-6">
                <SafeIcon icon={icons[index]} className="text-2xl text-orange-500" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{item.title}</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">{item.desc}</p>
              
              {/* Hub Link - Injected below Content Day description */}
              {index === 0 && (
                <Link to="/content-shooting" className="text-orange-500 hover:text-orange-400 text-sm font-semibold mt-2 inline-block transition-colors">
                  {t.hub.contentDay}
                </Link>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Deliverables;